// For backwards compatibility, make sure require("graphql-tag") returns
// the gql function, rather than an exports object.
module.exports = require('./lib/graphql-tag.umd.js').gql;



//////////////////
// WEBPACK FOOTER
// ./~/graphql-tag/main.js
// module id = 1022
// module chunks = 0